import 'css-chunksrc/client/pages/projectPage/ganttPage/projectEdition/styles.scss';export default {
  "projectEdition": "_projectEdition_12xcm_1",
  "title": "_title_12xcm_7",
  "group": "_group_12xcm_17",
  "text": "_text_12xcm_26",
  "name": "_name_12xcm_32",
  "main": "_main_12xcm_38",
  "buttons": "_buttons_12xcm_45",
  "button": "_button_12xcm_45",
  "loader": "_loader_12xcm_72",
  "loaderMain": "_loaderMain_12xcm_87"
};